let memoryStorageObject = {};
export const memoryStorage = {
    get length() {
        return Object.keys(memoryStorageObject).length;
    },
    clear: () => {
        memoryStorageObject = {};
    },
    getItem: (key) => {
        return memoryStorageObject[key] || null;
    },
    key: (index) => {
        return Object.keys(memoryStorageObject)[index] || null;
    },
    removeItem: (key) => {
        delete memoryStorageObject[key];
    },
    setItem: (key, value) => {
        memoryStorageObject[key] = value;
    }
};
export const localOrMemoryStorage = typeof localStorage !== 'undefined' ? localStorage : memoryStorage;
export const sessionOrMemoryStorage = typeof sessionStorage !== 'undefined' ? sessionStorage : memoryStorage;
